import { enGB, enUS, enCA, fr, de, es, nl, fi, pl } from 'date-fns/locale'

export function getUserLocale() {
  return document?.documentElement?.lang || 'en'
}

export function getOperatorCompanyLocale() {
  return document?.body?.dataset?.operatorCompanyLocale || getUserLocale();
}

export function getStripeLocale() {
  const userLocale = getUserLocale()

  if (userLocale === 'en-US' || userLocale === 'en-CA') {
    return 'en'
  }

  return userLocale
}

export function getDateFnsLocale() {
  const userLocale = getUserLocale()
  const localeMap = {
    en: enGB,
    'en-US': enUS,
    'en-CA': enCA,
    fr,
    de,
    es,
    nl,
    fi,
    pl,
  }

  return localeMap[userLocale] || enGB
}

export const SUPPORTED_LOCALES = ['de', 'en', 'en-CA', 'en-US', 'es', 'fr', 'nl', 'pl', 'fi']
